import { createBrowserHistory } from 'history';
export const sharedHistory = createBrowserHistory({basename: process.env.REACT_APP_PUBLIC_URL || ''})
export default sharedHistory;